import { HttpClient } from '@angular/common/http';
// import { environment } from '../../../../environments/environment';
import { API } from 'aws-amplify';
import { Observable } from 'rxjs';
import { ConfigService } from '../../config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../config/config.service";
var SalesHttpService = /** @class */ (function () {
    function SalesHttpService(http, configService) {
        this.http = http;
        this.configService = configService;
        this.apiName = this.configService.get('host');
    }
    SalesHttpService.prototype.getMachineSales = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get_machine_sales';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SalesHttpService.prototype.getSaleByMachine = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get_dyndb_sales_by_mid';
            var params = {
                body: queryParams
            };
            API.post(_this.apiName, path, params).then(function (macSales) {
                _this.getSaleCntByMachine(queryParams)
                    .then(function (countDet) {
                    var saleByMac = {
                        data: macSales.res_data,
                        LEK: macSales.LastEvaluatedKey,
                        count: countDet.Count
                    };
                    observer.next(saleByMac);
                })
                    .catch(function (error) {
                    observer.error(error);
                });
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SalesHttpService.prototype.getSaleCntByMachine = function (queryParams) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var path = '/dashboard/get_dyndb_sales_cnt_by_mid';
            var params = {
                body: queryParams
            };
            API.post(_this.apiName, path, params).then(function (macSalesCnt) {
                resolve(macSalesCnt);
            }).catch(function (err) {
                console.log(err.response);
                reject(err);
            });
        });
    };
    SalesHttpService.prototype.getSaleByMember = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get_dyndb_sales_by_member';
            var params = {
                body: queryParams
            };
            API.post(_this.apiName, path, params).then(function (macSales) {
                _this.getSaleCntByMember(queryParams)
                    .then(function (countDet) {
                    var saleByMac = {
                        data: macSales.res_data,
                        LEK: macSales.LastEvaluatedKey,
                        count: countDet.Count
                    };
                    observer.next(saleByMac);
                })
                    .catch(function (error) {
                    observer.error(error);
                });
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SalesHttpService.prototype.getSaleCntByMember = function (queryParams) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var path = '/dashboard/get_dyndb_sales_cnt_by_member';
            var params = {
                body: queryParams
            };
            API.post(_this.apiName, path, params).then(function (macSalesCnt) {
                resolve(macSalesCnt);
            }).catch(function (err) {
                console.log(err.response);
                reject(err);
            });
        });
    };
    SalesHttpService.prototype.getVendStatusCodes = function () {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get_vend_status_dict';
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (vend_codes) {
                var result = {};
                for (var _i = 0, vend_codes_1 = vend_codes; _i < vend_codes_1.length; _i++) {
                    var code = vend_codes_1[_i];
                    result[code.vend_code] = code.code_details;
                }
                observer.next(result);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SalesHttpService.prototype.getActivityCodes = function () {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get_user_act_dict';
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (ua_codes) {
                var result = {};
                for (var _i = 0, ua_codes_1 = ua_codes; _i < ua_codes_1.length; _i++) {
                    var code = ua_codes_1[_i];
                    result[code.sm_code] = code.sm_code_details;
                }
                observer.next(result);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SalesHttpService.prototype.getActivityLogs = function (trn_id) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get_user_act/' + trn_id;
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (ua_logs) {
                observer.next(ua_logs);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SalesHttpService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SalesHttpService_Factory() { return new SalesHttpService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: SalesHttpService, providedIn: "root" });
    return SalesHttpService;
}());
export { SalesHttpService };
